import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=6bd6a5c4&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/checkbox.css?vue&type=style&index=0&id=6bd6a5c4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6a5c4",
  null
  
)

export default component.exports